import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import { GetStaticPageRequest, StaticPage } from '@proto/store/api/store/static_page';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StaticPageRepositoryService {
  constructor(private http: LativHttpClient) {}

  getStaticPage(req: GetStaticPageRequest): Observable<StaticPage> {
    return this.http.get(`v1/static_page/${encodeURIComponent(req.id)}`).pipe(map(res => StaticPage.fromJSON(res)));
  }
}
